import { formatAutoJerryUpdatedDate } from './formatAutoJerryUpdatedDate';
import { isValidAutoJerryReviewsData } from './isValidAutoJerryReviewsData';

import type { AutoJerryReviewsData } from './parseAutoJerryHtml';

export interface CachedAutoJerryReviews {
  rating: number;
  reviewCount: number;
  updatedAt: string;
}

const STORAGE_KEY = 'autojerry-reviews';

const isValidCachedAutoJerryReviews = (data: unknown): data is CachedAutoJerryReviews => {
  if (!isValidAutoJerryReviewsData(data)) {
    return false;
  }

  const { updatedAt } = data as CachedAutoJerryReviews;

  return typeof updatedAt === 'string' && updatedAt.length > 0;
};

export const getCachedAutoJerryReviews = (): CachedAutoJerryReviews | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed: unknown = JSON.parse(raw);

    return isValidCachedAutoJerryReviews(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const setCachedAutoJerryReviews = (data: AutoJerryReviewsData): void => {
  try {
    const cached: CachedAutoJerryReviews = {
      ...data,
      updatedAt: formatAutoJerryUpdatedDate(new Date()),
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(cached));
  } catch {
    // Ignore quota errors and private browsing restrictions.
  }
};
